import React from 'react';
import { Link } from 'react-router-dom';
import { Seo } from '../shared';
import ExploreHero from '../explore/ExploreHero';
import FaqAccordion from '../explore/FaqAccordion';
import BookingTrustStrip from './BookingTrustStrip';
import { BOOK_EBC_SEO } from '../../data/bookEverestSeoContent';
import { EXPLORE_IMAGES } from '../../data/exploreImages';
import { SITE_URL } from '../../constants';
import '../../styles/booking-experience.scss';
import '../../styles/explore.scss';

const FAQ_SCHEMA = {
	'@context': 'https://schema.org',
	'@type': 'FAQPage',
	mainEntity: BOOK_EBC_SEO.faqs.map((f) => ({
		'@type': 'Question',
		name: f.q,
		acceptedAnswer: { '@type': 'Answer', text: f.a },
	})),
};

const TRIP_SCHEMA = {
	'@context': 'https://schema.org',
	'@type': 'TouristTrip',
	name: 'Everest Base Camp Trek',
	description: BOOK_EBC_SEO.description,
	touristType: 'Trekkers',
	itinerary: { '@type': 'ItemList', name: 'Everest Base Camp teahouse trek, 12–14 days from Kathmandu' },
	provider: { '@type': 'TravelAgency', name: 'Visit All Nepal', url: SITE_URL },
};

function BookEverestBaseCampPage() {
	const seo = BOOK_EBC_SEO;

	return (
		<div className="explore-page travel-services-page">
			<Seo
				title={seo.metaTitle}
				path="/book-everest-base-camp-trek"
				description={seo.description}
				keywords="book everest base camp trek online, everest base camp booking, ebc trek nepal, book ebc trek, everest trek online, nepal trekking booking"
				schema={[FAQ_SCHEMA, TRIP_SCHEMA]}
			/>
			<ExploreHero
				image={EXPLORE_IMAGES.trekking}
				eyebrow="Book online"
				title={seo.title}
				lead={seo.lead}
				compact
				booking
			/>
			<div className="explore-body container travel-services-page__body">
				<div className="travel-services-page__cards-panel">
					<div className="travel-services-page__booking-header">
						<h2 className="travel-services-page__booking-title">Reserve your EBC trek</h2>
						<p className="travel-services-page__intro">
							Pick how you want to travel — then read the free planner if you are still deciding dates or fitness.
						</p>
					</div>
					<div className="home-experience-band__grid travel-services-page__grid" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))' }}>
						<Link to="/group-trips" className="experience-card experience-card--primary">
							<span className="experience-card__badge">Most popular</span>
							<span className="experience-card__emoji" aria-hidden="true">🏔</span>
							<h3 className="experience-card__title">Join a group departure</h3>
							<p className="experience-card__lead">Fixed EBC dates — reserve with a deposit online.</p>
							<span className="experience-card__btn">Browse group trips</span>
						</Link>
						<Link to="/packages" className="experience-card">
							<span className="experience-card__badge">Your dates</span>
							<span className="experience-card__emoji" aria-hidden="true">🎒</span>
							<h3 className="experience-card__title">Private EBC trek</h3>
							<p className="experience-card__lead">Custom dates and pace — request a quote.</p>
							<span className="experience-card__btn">Request private tour</span>
						</Link>
						<Link to="/journeys/everest-base-camp" className="experience-card">
							<span className="experience-card__badge">Free planner</span>
							<span className="experience-card__emoji" aria-hidden="true">🗺</span>
							<h3 className="experience-card__title">EBC journey guide</h3>
							<p className="experience-card__lead">Day-by-day plan, budget, permits, packing — no booking required.</p>
							<span className="experience-card__btn">Open EBC planner</span>
						</Link>
					</div>
				</div>

				<div className="travel-services-page__trust">
					<BookingTrustStrip light />
				</div>

				<section className="travel-services-page__editorial" aria-label="Everest Base Camp booking guide">
					{seo.sections.map((section) => (
						<article key={section.id} className="travel-services-page__editorial-block">
							<h2 className="travel-services-page__editorial-title">{section.title}</h2>
							{section.paragraphs.map((p) => (
								<p key={p.slice(0, 48)} className="travel-services-page__editorial-text">{p}</p>
							))}
						</article>
					))}
				</section>

				<section className="travel-services-page__editorial">
					<h2 className="travel-services-page__editorial-title">Frequently asked questions</h2>
					<FaqAccordion items={seo.faqs} />
				</section>

				<p className="text-center text-muted small mb-0">
					Also see{' '}
					<Link to="/destinations/everest-base-camp">Everest Base Camp destination guide</Link>
					{' · '}
					<Link to="/guides/choosing-your-first-trek-in-nepal">Choosing your first trek</Link>
					{' · '}
					<Link to="/trekking">Trekking hub</Link>
				</p>
			</div>
		</div>
	);
}

export default BookEverestBaseCampPage;
